import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkConnection, flatConnectionStates } from '@fttb/common';
import { isPlainObject } from '@beef/utils';
import { fetchLowSpeedTariffs } from "../../../../../services/fetchLowSpeedTariffs";
import { ERROR_TYPES } from "../../../../../store/constants";
import { getIsHighSpeedTariff } from "../selectors/tariffDetails";
import { getTargetTariffGroup } from "../selectors/orderTariffCommon";
export var fetchCheckConnection = createAsyncThunk('fetchCheckConnection', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connectionData, _ref) {
    var getState, rejectWithValue, state, result, isHighSpeedTariff, _ref3, _ref3$data, IsSucceeded, View, ConnectionState, HighSpeedAvailable, tariffGroup, _yield$fetchLowSpeedT, isSucceeded, tariff;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState, rejectWithValue = _ref.rejectWithValue;
          _context.prev = 1;
          state = getState();
          _context.next = 5;
          return checkConnection(connectionData);
        case 5:
          result = _context.sent;
          isHighSpeedTariff = getIsHighSpeedTariff(state);
          _ref3 = result || {}, _ref3$data = _ref3.data, IsSucceeded = _ref3$data.IsSucceeded, View = _ref3$data.View;
          ConnectionState = View.ConnectionState, HighSpeedAvailable = View.HighSpeedAvailable;
          if (!((ConnectionState === flatConnectionStates.success || ConnectionState === flatConnectionStates.alreadyInUse) && HighSpeedAvailable === 0 && isHighSpeedTariff)) {
            _context.next = 19;
            break;
          }
          tariffGroup = getTargetTariffGroup(state);
          _context.next = 13;
          return fetchLowSpeedTariffs(tariffGroup);
        case 13:
          _yield$fetchLowSpeedT = _context.sent;
          isSucceeded = _yield$fetchLowSpeedT.isSucceeded;
          tariff = _yield$fetchLowSpeedT.view;
          if (!(!isSucceeded || !isPlainObject(tariff))) {
            _context.next = 18;
            break;
          }
          throw new Error(ERROR_TYPES.emptyAddress);
        case 18:
          return _context.abrupt("return", {
            tariff: tariff,
            View: View,
            IsSucceeded: IsSucceeded
          });
        case 19:
          return _context.abrupt("return", {
            View: View,
            IsSucceeded: IsSucceeded
          });
        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](1);
          if (!(_context.t0 instanceof Error)) {
            _context.next = 26;
            break;
          }
          return _context.abrupt("return", rejectWithValue(_context.t0.message));
        case 26:
          throw new Error();
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 22]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());